var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 56,
    viewBox: "0 0 55 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_939_2929)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6658 10.5903L24.8952 11.0683L25.4197 11.1466L34.7751 12.5441L34.7797 12.5448C35.1691 12.6011 35.5127 12.884 35.645 13.288C35.7756 13.6932 35.67 14.1326 35.3731 14.4354C35.3721 14.4364 35.3712 14.4373 35.3702 14.4383L28.5932 21.1683L28.2269 21.532L28.3113 22.0413L29.9127 31.7038C29.9127 31.7041 29.9128 31.7044 29.9128 31.7046C29.983 32.133 29.8079 32.554 29.4759 32.7927L29.472 32.7955C29.1354 33.0399 28.6953 33.0676 28.3403 32.8761L19.9814 28.361L19.506 28.1042L19.0306 28.3612L10.682 32.8743C10.6814 32.8746 10.6807 32.875 10.6801 32.8753C10.3156 33.0691 9.87483 33.0383 9.54037 32.7955C9.20649 32.553 9.0326 32.1298 9.10486 31.7117L9.10488 31.7117L9.10601 31.7049L10.7076 22.0413L10.792 21.532L10.4256 21.1682L3.64422 14.4351C3.3486 14.1341 3.24269 13.6947 3.37385 13.2861C3.50429 12.8843 3.84439 12.6016 4.23943 12.5449L4.23944 12.5449L4.24519 12.5441L13.5928 11.1466L14.1168 11.0683L14.3463 10.5908L18.539 1.8679L18.5409 1.86387C18.7215 1.48384 19.1007 1.24756 19.5062 1.24756C19.92 1.24756 20.2982 1.48546 20.478 1.86387L20.4796 1.86735L24.6658 10.5903Z",
    stroke: "#020000",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_939_2929"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.5,
    height: 33.75,
    fill: "white",
    transform: "translate(0.75 0.25)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStar);
export default __webpack_public_path__ + "static/media/icon_star.939580c8a0a73b282c4e2f0a5dda6d0d.svg";
export { ForwardRef as ReactComponent };